export const translations = {
  id: {
    pt: 'ID',
    en: 'ID',
    es: 'ID',
    de: 'ID',
  },

  codigoSAP: {
    pt: 'Cód. ERP',
    en: 'ERP code',
    de: 'ERP-Code',
    es: 'Cód. ERP',
  },

  name: {
    pt: 'Nome',
    en: 'Name',
    de: 'Name',
    es: 'Nombre',
  },

  commercialRole: {
    pt: "Função Comercial",
    en: "Commercial Role",
    de: "Kommerzielle Rolle",
    es: "Rol Comercial",
  },

  phoneNumber: {
    pt: 'Número de telefone',
    en: 'Phone Number',
    de: 'Telefonnummer',
    es: 'Número de teléfono',
  },

  adicionar: {
    pt: 'Adicionar',
    en: 'To add',
    de: 'Hinzufügen',
    es: 'Para agregar',
  },
  selecione: {
    pt: 'Selecione...',
    en: 'Select...',
    de: 'Wählen Sie...',
    es: 'Seleccione...',
  },
};
